export const STACK = Object.freeze({
  PROD: "PROD",
  PROD2: "PROD2",
  PRODCA: "PRODCA", // canada
  STAGE: "STAGE",
  DEV: "DEV",
});

const stack = process.env.FEATURE_FLAGS_STACK;

const flags = {
  CLASS_PROGRESS_REPORT: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  MOCK_ERSS_SKILLS_DIAGNOSTIC: {
    [STACK.PROD]: false,
    [STACK.PROD2]: false,
    [STACK.PRODCA]: false,
    [STACK.STAGE]: false,
    [STACK.DEV]: false,
  },
  DYSLEXIA_PARENT_LETTERS: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  UTTERANCE_LOGS: {
    [STACK.PROD]: false,
    [STACK.PROD2]: false,
    [STACK.PRODCA]: false,
    [STACK.STAGE]: false,
    [STACK.DEV]: false,
  },
  SESSION_LOGS: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  SYSTEM_LOGS: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  INTERVENTION_LOGS: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  SPEECH_LOGS: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  ENABLE_SENTRY_USER_LOGGING: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: false,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  ENABLE_COMMON_SENTRY_ERROR_LOGGING: {
    [STACK.PROD]: false,
    [STACK.PROD2]: false,
    [STACK.PRODCA]: false,
    [STACK.STAGE]: false,
    [STACK.DEV]: false,
  },
  UNIVERSAL_GENERATIVE_VOICE: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  STUDENT_INBOX: {
    [STACK.PROD]: false,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: false,
    [STACK.DEV]: true,
  },
  AOS: {
    [STACK.PROD]: false,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: false,
    [STACK.DEV]: true,
  },
  VOLUME_CHECK_DEBUG_TELEMETRY: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  IES_ENABLED: {
    [STACK.PROD]: false,
    [STACK.PROD2]: false,
    [STACK.PRODCA]: false,
    [STACK.STAGE]: false,
    [STACK.DEV]: false,
  },
  ENABLE_MIC_MUTED_ERROR_MODAL: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  ENABLE_AUDIO_PROCESSING_CONSTRAINTS: {
    [STACK.PROD]: false,
    [STACK.PROD2]: false,
    [STACK.PRODCA]: false,
    [STACK.STAGE]: false,
    [STACK.DEV]: false,
  },
  MUTED_AUDIO_FULL_TROUBLESHOOT: {
    [STACK.PROD]: false,
    [STACK.PROD2]: false,
    [STACK.PRODCA]: false,
    [STACK.STAGE]: false,
    [STACK.DEV]: false,
  },
  WAIT_FOR_ASR_CONNECTION: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  ENABLE_KALDI_FOR_UPDOWN: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  /**
   * Fleet-wide enable for the new Spanish PM in shouldUseNewSpanishPlacementManagerForCurrentSession.
   * Gating differs by session type: in TUTOR this flag alone enables the new Spanish PM for any
   * es-mx district (legacy included); in ASSESSMENT it is AND'd with the per-district evaluarBTS
   * license, so legacy districts stay on the legacy Google assessment path and only BTS-licensed
   * districts get the new PM in assessment. True everywhere; flip to false here to instantly
   * disable the new Spanish PM fleet-wide (e.g. a production incident). Per-district opt-out
   * remains via the forceNewSpanishASROff app setting.
   */
  USE_NEW_SPANISH_PM: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  /**
   * Global override for routing Spanish (es-mx) assessments through AOS, OR-ed with the
   * per-district BTS license in shouldUseAOS (ASSMNT-1702). Disabled on every stack during
   * rollout — Spanish-AOS is license-gated for now. Flip a stack to true once no school there
   * is still on legacy pathways, to enable Spanish-AOS fleet-wide regardless of license.
   */
  USE_SPANISH_AOS: {
    [STACK.PROD]: false,
    [STACK.PROD2]: false,
    [STACK.PRODCA]: false,
    [STACK.STAGE]: false,
    [STACK.DEV]: false,
  },
  /**
   * Gates generative TTS for es-mx (with brand allow-list); Spanish pilot URL param bypasses the flag.
   * ASSMNT-1799: fleet-wide kill switch, AND'd with the per-district evaluarBTS license in
   * shouldUseNewSpanishVoice. True everywhere so the license is the only lever in normal
   * operation; flip to false here to instantly disable the new Spanish voice fleet-wide
   * regardless of license.
   */
  USE_NEW_SPANISH_VOICE: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  /**
   * ASSMNT-1003: Play the es-mx listening-comprehension activity intro (post-pilot). OR'd with the
   * per-district evaluarBTS license (isBTSEffective) in getActivityIntroText — the license alone
   * enables it, so licensed districts can validate in production while this stays off. Left off in
   * prod until fleet-wide rollout; forceEnableSpanishLcIntro URL param overrides for QA.
   */
  ENABLE_SPANISH_LC_INTRO: {
    [STACK.PROD]: false,
    [STACK.PROD2]: false,
    [STACK.PRODCA]: false,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  /** ASSMNT-1044: ORF passages — downlevel one grade when 4-minute passage timer expires; exit as prereader only when downleveling from kindergarten. */
  ENABLE_ORF_4MIN_TIMER_DOWNLEVEL: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  /** Gates AudioWorklet usage in recorder.js; falls back to ScriptProcessorNode when disabled. */
  ENABLE_AUDIO_WORKLET: {
    [STACK.PROD]: false,
    [STACK.PROD2]: false,
    [STACK.PRODCA]: false,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  /** TT-825: Gates client-side (on-device) ASR placement, including ASR asset pre-caching and the post-init silent warmup. en-us locale gating is applied at the wiring layer (TT-828). */
  ENABLE_LOCAL_ASR: {
    [STACK.PROD]: true,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  /** Selects the on-device ASR backend when ENABLE_LOCAL_ASR is on: 'vosk' (default) or 'nemo'. Override per-session with forceLocalAsrBackend. */
  LOCAL_ASR_BACKEND: {
    [STACK.PROD]: 'vosk',
    [STACK.PROD2]: 'vosk',
    [STACK.PRODCA]: 'vosk',
    [STACK.STAGE]: 'vosk',
    [STACK.DEV]: 'vosk',
  },
  /** TT-935: Gates the "how to work with Amira" intro video that plays at the start of the Ready Module. Legacy PROD is still dark pending its own rollout. Override per-session with forceReadyModuleIntroVideo. */
  ENABLE_READY_MODULE_INTRO_VIDEO: {
    [STACK.PROD]: false,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  /** TT-1378 / CR-10713: when true, a browser that will not render images fails the Hardware pre-check with a text-only fix screen; the session cannot start until images are allowed again. When false the probe still runs and logs images_blocked, but never blocks. Override per-session with forceImageRenderPrecheck. */
  ENABLE_IMAGE_RENDER_PRECHECK: {
    [STACK.PROD]: false,
    [STACK.PROD2]: true,
    [STACK.PRODCA]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
};

/**
 * @param {string|number} districtId - The district ID to check
 * @returns {boolean} True if new struggling reader criteria should be used
 */
const USE_NEW_STRUGGLING_READER_CRITERIA = (districtId) => {
  return true;
};

/**
 * Reads an optional debug URL override for a boolean feature flag.
 * @param {string} paramName - Query param name (e.g. forceUseNewSpanishPM)
 * @returns {boolean|undefined} true/false when set; undefined when absent (use stack default)
 */
function getUrlBooleanFlagOverride(paramName) {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const value = new URLSearchParams(window.location.search).get(paramName);
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return undefined;
}

/**
 * Reads an optional debug URL override for a string feature flag.
 * @param {string} paramName
 * @returns {string|undefined} Trimmed value when set and non-empty; otherwise undefined.
 */
function getUrlStringFlagOverride(paramName) {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const value = new URLSearchParams(window.location.search).get(paramName);
  const trimmed = value && value.trim();
  return trimmed ? trimmed : undefined;
}

/**
 * @returns {boolean} True for production stacks where large-download debug overrides
 *   should not be enabled from a public URL.
 */
function isProductionStack() {
  return [STACK.PROD, STACK.PROD2, STACK.PRODCA].includes(stack);
}

const forceUseNewSpanishPM = getUrlBooleanFlagOverride('forceUseNewSpanishPM');
const forceUseNewSpanishVoice = getUrlBooleanFlagOverride('forceUseNewSpanishVoice');
const forceEnableAudioWorklet = getUrlBooleanFlagOverride('forceEnableAudioWorklet');
const forceEnableSpanishLcIntro = getUrlBooleanFlagOverride('forceEnableSpanishLcIntro');
const forceTapToRead = getUrlBooleanFlagOverride('forceTapToRead');
const forceCursorFree = getUrlBooleanFlagOverride('forceCursorFree');
const forceBadSignalCursor = getUrlBooleanFlagOverride('forceBadSignalCursor');
const forceBadSignalLogOnly = getUrlBooleanFlagOverride('forceBadSignalLogOnly');
const forceLowAudio = getUrlBooleanFlagOverride('forceLowAudio');
const forceStaticAudio = getUrlBooleanFlagOverride('forceStaticAudio');
const forceClippedAudio = getUrlBooleanFlagOverride('forceClippedAudio');
const forceDeadSilenceAudio = getUrlBooleanFlagOverride('forceDeadSilenceAudio');
const forcePervasiveClippingAudio = getUrlBooleanFlagOverride('forcePervasiveClippingAudio');
const forceHighRttNetwork = getUrlBooleanFlagOverride('forceHighRttNetwork');
const forceLocalAsrBackend = getUrlStringFlagOverride('forceLocalAsrBackend');
const forceReadyModuleIntroVideo = getUrlBooleanFlagOverride('forceReadyModuleIntroVideo');
const forceImageRenderPrecheck = getUrlBooleanFlagOverride('forceImageRenderPrecheck');
const forceLocalAsrWarmup = getUrlBooleanFlagOverride('forceLocalAsrWarmup');

// Generate FEATURE_FLAGS based on the current stack
export const FEATURE_FLAGS = {
  ...Object.fromEntries(
    Object.entries(flags).map(([key, value]) => [key, value[stack]])
  ),
  // Add function-based feature flags here:
  USE_NEW_STRUGGLING_READER_CRITERIA,
  ...(forceUseNewSpanishPM !== undefined ? { USE_NEW_SPANISH_PM: forceUseNewSpanishPM } : {}),
  ...(forceUseNewSpanishVoice !== undefined ? { USE_NEW_SPANISH_VOICE: forceUseNewSpanishVoice } : {}),
  ...(forceEnableAudioWorklet !== undefined ? { ENABLE_AUDIO_WORKLET: forceEnableAudioWorklet } : {}),
  ...(forceEnableSpanishLcIntro !== undefined ? { ENABLE_SPANISH_LC_INTRO: forceEnableSpanishLcIntro } : {}),
  ...(forceLocalAsrBackend !== undefined && !isProductionStack() ? { LOCAL_ASR_BACKEND: forceLocalAsrBackend } : {}),
  ...(forceReadyModuleIntroVideo !== undefined ? { ENABLE_READY_MODULE_INTRO_VIDEO: forceReadyModuleIntroVideo } : {}),
  ...(forceImageRenderPrecheck !== undefined ? { ENABLE_IMAGE_RENDER_PRECHECK: forceImageRenderPrecheck } : {}),
};

export const FORCE_TAP_TO_READ = forceTapToRead;

/**
 * Debug override: ?forceCursorFree=true|false forces cursor-free ("cursor off") tutor
 * mode on or off, bypassing the district threshold / WCPM / onboarding-ramp gating.
 * undefined (param absent) means the normal eligibility logic decides.
 */
export const FORCE_CURSOR_FREE = forceCursorFree;

/**
 * Debug override for the TT-991 bad-signal cursor gate: ?forceBadSignalCursor=true|false
 * stands in for the badSignalCursorEnabled license flag so the branch can be exercised in a
 * browser. Honoured on every stack, production included, like FORCE_TAP_TO_READ and
 * FORCE_CURSOR_FREE. undefined (param absent) means the license decides.
 *
 * A session driven by this param never persists anything to the student -- see
 * cursor/signalThresholds.isBadSignalForcedSession -- which is what makes it safe to use on a
 * production district: the tester's own account cannot be latched by it.
 */
export const FORCE_BAD_SIGNAL_CURSOR = forceBadSignalCursor;

/**
 * Debug override for TT-991's dark-launch switch: ?forceBadSignalLogOnly=true|false stands in for
 * the BAD_SIGNAL_LOG_ONLY build constant, so both halves of the rollout -- decide and log only,
 * decide and apply -- are reachable in a browser on any build. Honoured on every stack.
 */
export const FORCE_BAD_SIGNAL_LOG_ONLY = forceBadSignalLogOnly;

/**
 * Which fake-bad-audio conditions the TT-991 prior-activity signal should be fabricated from,
 * reusing the three params the Debug Menu already offers. Those params only flip ReaderManager's
 * derived detector booleans, which the stashed signal never reads, so without this the branch
 * cannot be exercised without genuinely bad audio on a real device.
 *
 * ?forceDeadSilenceAudio and ?forcePervasiveClippingAudio fabricate TT-1230's two high-precision
 * branches, the only route to any bad-signal outcome. ONLY those two actually substitute the
 * stashed signal (see ReaderManager.stashLiveActivitySignals) and only they mark the session
 * forced (see cursor/signalThresholds.isBadSignalForcedSession); the three older params are read
 * here so a combined run (e.g. dead silence AND low volume) still fabricates the extra
 * measurements, but on their own they do NOT replace the real signal -- doing so would silently
 * mask a genuinely bad prior activity, and they cannot reach a mode regardless.
 *
 * undefined when no param is set. Honoured on every stack; a fabricated signal is flagged in
 * the session log (cursor_bad_signal_audio_forced) so it cannot be mistaken for a measurement.
 */
export const FORCE_BAD_SIGNAL_AUDIO = (forceLowAudio === true || forceStaticAudio === true || forceClippedAudio === true
    || forceDeadSilenceAudio === true || forcePervasiveClippingAudio === true)
  ? Object.freeze({
    lowVolume: forceLowAudio === true,
    staticLowBand: forceStaticAudio === true,
    clipped: forceClippedAudio === true,
    deadSilence: forceDeadSilenceAudio === true,
    pervasiveClipping: forcePervasiveClippingAudio === true,
  })
  : undefined;

/**
 * Debug override for GT-306's bad-network rule: ?forceHighRttNetwork=true stands in for the
 * student's login tutor history with a fabricated one that trips TT-1377's rule (two high-RTT
 * sessions on two calendar days), so the network half of the branch can be exercised in a browser
 * without a genuinely slow network across several days. Like the audio params it marks the
 * session forced (cursor/signalThresholds.isBadSignalForcedSession) so nothing is persisted to the
 * student, and the fabricated history is flagged in the decision log. Honoured on every stack.
 * undefined when the param is absent; only an exact true substitutes.
 */
export const FORCE_BAD_SIGNAL_NETWORK = forceHighRttNetwork;

/**
 * Debug override: ?forceLocalAsrWarmup=true bypasses the warmup verdict gate so
 * local ASR is used regardless of device speed measurement. The warmup still runs
 * and logs telemetry — only the routing decision is overridden. Non-prod only.
 * false / absent both mean default behavior (warmup verdict gates normally).
 */
export const FORCE_LOCAL_ASR_WARMUP = (forceLocalAsrWarmup === true && !isProductionStack()) ? true : undefined;
